import { createRoot } from 'react-dom/client';

import Carousel from './quote-carousel/Carousel';
import CarouselQuote from './quote-carousel/CarouselQuote';

// Animate bar charts on scroll into view
function animateBarChartsOnView() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const bars = document.querySelectorAll('.bar');
    const textContainers = document.querySelectorAll('.chart-text-container');
    bars.forEach(bar => {
        if (!bar.dataset.finalHeight) {
            bar.dataset.finalHeight = bar.style.height;
        }
        if (prefersReducedMotion) {
            bar.style.height = bar.dataset.finalHeight;
            bar.style.transition = 'none';
        } else {
            bar.style.height = '0px';
            bar.style.transition = 'height 1s cubic-bezier(0.4, 0, 0.2, 1)';
        }
    });
    textContainers.forEach(textContainer => {
        if (prefersReducedMotion) {
            textContainer.style.opacity = '1';
            textContainer.style.transition = 'none';
        } else {
            textContainer.style.opacity = '0';
            textContainer.style.transition = 'opacity 1s cubic-bezier(0.4, 0, 0.2, 1)';
        }
    });

    if (prefersReducedMotion) {
        // No need for IntersectionObserver, everything is already visible
        return;
    }

    const observer = new window.IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const bar = entry.target;
                bar.style.height = bar.dataset.finalHeight;
                const chartFlex = bar.closest('.funding-chart-flex');
                if (chartFlex) {
                    const textContainer = chartFlex.querySelector('.chart-text-container');
                    if (textContainer) {
                        textContainer.style.opacity = '1';
                    }
                }
                obs.unobserve(bar);
            }
        });
    }, {
        threshold: 0.3,
    });

    bars.forEach(bar => {
        observer.observe(bar);
    });
}

document.addEventListener('DOMContentLoaded', animateBarChartsOnView);

$(() => {
    const root = createRoot(document.getElementById('efs-landing-teacherquotecarousel'));

    root.render(<Carousel>
        <CarouselQuote
            quote={"I wish you could have seen the looks on the student's faces when they walked into this room! From the bottom of my heart: Thank you for making this dream a reality. When you are a teacher and have big ideas, you often are at a standstill due to finances. These donations allowed me to leap over that hurdle and do what is right for our students."}
            name={'Mrs. Williams'}
            location={'Sonoma, CA'}
        />
        <CarouselQuote
            quote={"In our current reality of budget cuts, high-stakes testing, and socio-economic disparity, it can often feel like I am the only one fighting for my kids. The DonorsChoose community reminds me that I am not alone. It's given me much-needed tools to create educational experiences that will help our young readers become tomorrow's great leaders!"}
            name={'Ms. Sellers'}
            location={'Commerce City, CO'}
        />
        <CarouselQuote
            quote={"My students couldn't believe that someone we didn't even know had funded a project for them."}
            name={'Ms. Mitchell'}
            location={'Dawson, GA'}
        />
        <CarouselQuote
            quote={'DonorsChoose enables everyday, caring people to make such a difference in the lives of these very deserving students.'}
            name={'Ms. Bowman'}
            location={'Houston, TX'}
        />
        <CarouselQuote
            quote={'I cannot imagine teaching without DonorsChoose. You are such a blessing not only for students, but for teachers as well.'}
            name={'Ms. Sorenson'}
            location={'Wichita, KS'}
        />
        <CarouselQuote
            quote={"My students were like: 'Someone is giving this to us? This is so amazing!' At this point I like to say my classroom runs on DonorsChoose. The support that we're getting — from furniture to books to resources to even a science curriculum at one point — it's just been amazing."}
            name={'Mrs. Fisher'}
            location={'Randolph, MA'}
        />
        <CarouselQuote
            quote={'I believe that all students deserve access to these basic supplies. Without DonorsChoose, our classroom simply would not have them.'}
            name={'Ms. Maller'}
            location={'New York, NY'}
        />
    </Carousel>);
});

if (userObj.isTTD === true || userObj.isVIP === true) {
    $('.wtg-banner').show();
    $('.wtg-banner').show();
}
